import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { ReactComponent as Trucksvg } from 'images/truck.svg';
import { FullWidthPaperContent } from 'components/Paper';
import Address from 'components/Address';
import WidgetContainer from 'components/widget/WidgetContainer';
import TextLink from 'components/TextLink';
import AddressesContainerPath from 'containers/paths/AddressesContainerPath';
import InfoBox from 'components/widget/InfoBox';
import ordersRoutePath from 'containers/paths/OrdersContainerPath';

const ImageWrapper = styled(FullWidthPaperContent)`
  text-align: center;
  background-color: ${({ theme }) => theme.palette.colors.turquoise};
  margin-top: ${({ theme }) => theme.spacing * 2}px;
  svg {
    height: 148px;
    width: auto;
  }
`;

const AddressWidget = ({ pack, canChangeAddress }) => (
  <WidgetContainer
    title="Address"
    titleRightElement={canChangeAddress && (
      <TextLink
        props={{ to: AddressesContainerPath() }}
      >
        See all addresses
      </TextLink>
    )}
  >
    <h4>Your next delivery will be sent to</h4>
    <Address address={pack.deliveryAddress} />
    { canChangeAddress
      && (
        pack.status === 'Pending'
          ? (
            <TextLink
              dataLayer={{ action: 'Change Delivery Address Click', label: 'Change Delivery Address' }}
              props={{ to: ordersRoutePath(pack.id, 'changeAddress?enableApplyToAll=true&enablePrimary=true') }}
              rightChevron
            >
              Change delivery address
            </TextLink>
          ) : (
            <InfoBox>
              As the next order is already been processed, we can not change the delivery address.
              You can change all your future delivery addresses from the&nbsp;
              <TextLink props={{ to: AddressesContainerPath() }}>Addresses</TextLink>
              &nbsp;section instead.
            </InfoBox>
          )
      )}
    <ImageWrapper>
      <Trucksvg />
    </ImageWrapper>
  </WidgetContainer>
);

export default AddressWidget;

AddressWidget.propTypes = {
  canChangeAddress: PropTypes.bool,
  pack: PropTypes.shape({
    id: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
    deliveryAddress: PropTypes.shape({}).isRequired,
  }).isRequired,
};

AddressWidget.defaultProps = {
  canChangeAddress: false,
};
